// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"cb7cfae1","768":"e7d43c6b"}[chunkId] + ".chunk.js";
};